import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Button from "../../../../Core/Button/Button.jsx";
import Table1 from "./Table1";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 py-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="date"
                      label="Series"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Entry Type"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="From Template"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) =>
                        handleChange("ClosingAccountHead", val)
                      }
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      label="Company GSTIN"
                      style={{
                        height: "30px",
                      }}
                      placeholder="0.55555"
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <label htmlFor="" style={{ fontSize: "0.8rem" }}>
                      Posting Date
                    </label>
                    <input
                      type="date"
                      className="form-control tableinput noborder"
                      style={{ fontSize: "0.8rem" }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#E3F5DF",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      label=" Reference Number"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Input
                      id="date"
                      label=" Reference Date"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: "0.8rem" }}>Remarks</label>
                    <textarea
                      className="form-control tableinput noborder"
                      rows={2}
                      style={{ fontSize: "0.8rem" }}
                      value={pageState.Remarks || ""}
                      onChange={(e) => handleChange("Remarks", e.target.value)}
                      placeholder="Enter remarks"
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ height: "20.4px" }}></label>
                    <Checkbox id="forbuying" label="For Buying" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <div
          className="col-md-12 px-2"
          style={{ display: "flex", gap: "20px" }}
        >
          <div
            className=""
            style={{
              height: "100%",
              borderRadius: "4px",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: "10px",
              border: "1px solid #DBDBDB",
              borderRadius: "5px",
            }}
          >
            <div style={{ display: "flex", gap: "15px" }}>
              <div style={{ flex: 1 }}>
                <p className="" style={{ fontSize: "16px", fontWeight: "600" }}>
                  Cost Center Allocation Percentages
                </p>
              </div>
            </div>
            <Table1 setselected_item_data={setselected_item_data} />
          </div>
        </div>
      </div>

      <div className="mb-3 px-3 " style={{ display: "flex", gap: "20px" }}>
        <div className="col-md-5 px-2" style={{ display: "flex" }}>
          <div
            style={{
              background: "#FBF4F4",
              borderRadius: "6px",
              padding: "12px",
              width: "360px",
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: "10px" }}>Totals</div>

            {/* Total Debit */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
                fontSize: "0.85rem",
              }}
            >
              <span style={{ color: "#6c757d" }}>Total Debit</span>
              <span style={{ fontWeight: 500 }}>₹ 1000.00</span>
            </div>

            {/* Total Credit */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
                fontSize: "0.85rem",
              }}
            >
              <span style={{ color: "#6c757d" }}>Total Credit</span>
              <span style={{ fontWeight: 500 }}>₹ 500.00</span>
            </div>

            {/* Difference */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "12px",
                fontSize: "0.85rem",
              }}
            >
              <span style={{ color: "#6c757d" }}>Difference (Dr - Cr)</span>
              <span style={{ fontWeight: 500 }}>₹ 500.00</span>
            </div>

            {/* Button */}
            <div style={{ display: "flex", gap: "15px" }}>
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <Button
                    className="custom-btn"
                    style={{
                      gap: "2px",
                      height: "28px",
                      background: "#425166",
                      width: "100%",
                      fontSize: "0.8rem",
                      color:"#ffffff",
                      borderRadius: "0.2rem"

                    }}
                  
                  >
                    Make Difference Entry
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
